export default __webpack_public_path__ + "static/media/teams_selected.b4841838.mp3";